import { render, staticRenderFns } from "./CloseRouteColumnTemplate.vue?vue&type=template&id=cd1b4f38"
import script from "./CloseRouteColumnTemplate.vue?vue&type=script&lang=js"
export * from "./CloseRouteColumnTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports